import { Box, Stack, Typography } from '@mui/material';

import { themeColors, brandColors } from 'colors';
import { Campaign } from 'domains/campaigns/types';

type SendingWinnerStatusProps = {
    campaign: Campaign;
};

const SendingWinnerStatus = ({ campaign }: SendingWinnerStatusProps) => {
    const winnerSend = campaign.sends?.find((send) => send.id === campaign.abTestConfig?.winnerSendId);
    const winnerName = winnerSend?.name || 'Winner';

    return (
        <Box
            sx={{
                backgroundColor: brandColors.garlic,
                borderRadius: '8px',
                padding: '16px',
                paddingLeft: '24px',
            }}
        >
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="baseline" spacing={1.4}>
                    <Box
                        sx={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: themeColors.other.ratingActive,
                        }}
                    />
                    <Typography>sending winner</Typography>
                </Stack>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Sending '{winnerName}' to remaining contacts
                </Typography>
            </Stack>
        </Box>
    );
};

export default SendingWinnerStatus;
